/* eslint-disable no-console */
import { createApp } from 'vue';
/* eslint-disable no-console */
import axios from 'axios';
/* eslint-disable no-console */
import App from './App.vue';
/* eslint-disable no-console */
import router from './routes';
/* eslint-disable no-console */
import store from './store';
/* eslint-disable no-console */
import 'bootstrap/dist/css/bootstrap.css';
/* eslint-disable no-console */
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
/* eslint-disable no-console */
import './assets/css/gdq_web.css';
/* eslint-disable no-console */
import './assets/css/gdqfont.css';
/* eslint-disable no-console */
import './assets/custom.scss';
/* eslint-disable no-console */
import { registerIcons } from './plugins/fontawesome';
/* eslint-disable no-console */
import { registerBootstrapIconShims } from './plugins/bootstrapIcons';

// Import Quill for VueEditor component
/* eslint-disable no-console */
import Quill from 'quill';
/* eslint-disable no-console */
import 'quill/dist/quill.snow.css';

// Make Quill available globally for our custom VueEditor
if (typeof window !== 'undefined') {
  window.Quill = Quill;
}

const accessToken = localStorage.getItem('gdq_atoken');
if (accessToken) {
  axios.defaults.headers.common['Authorization'] = accessToken;
}

// Suppress noisy ResizeObserver loop errors from dev overlay.
if (typeof window !== 'undefined') {
  const ignoreResizeObserverError = (e) => {
    if (e?.message?.includes('ResizeObserver loop')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return true;
    }
  };
  window.addEventListener('error', ignoreResizeObserverError, true);
  window.addEventListener('unhandledrejection', ignoreResizeObserverError, true);

  // Also silence console.error spam for the same message.
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (args && args[0] && args[0].toString().includes('ResizeObserver loop')) {
      return;
    }
    originalConsoleError(...args);
  };

  // Fallback for handlers that bypass addEventListener.
  const origOnError = window.onerror;
  window.onerror = (msg, src, line, col, err) => {
    if (msg && msg.toString().includes('ResizeObserver loop')) {
      return true;
    }
    if (origOnError) {
      return origOnError(msg, src, line, col, err);
    }
    return false;
  };
}

const app = createApp(App);

registerIcons(app);
registerBootstrapIconShims(app);
app.use(store);
app.use(router);
app.mount('#app');
